import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import fileDownload from 'js-file-download';
import { checkServerLive } from 'constants/config';
import { ShowIf } from 'components/utils';
import {downloadFile} from 'components/utils';

export default class ListAttachTaiLieuRowItem extends React.Component {

  render() {
    return (
      <tr>
        <td>{(this.props.count) ? this.props.count : ''}</td>
        <td>{(this.props.item.ten) ? this.props.item.ten : ''}</td>
        <td>{(this.props.item.soQuyetDinh) ? this.props.item.soQuyetDinh : ''}</td>
        <td>{(this.props.item.ngayQuyetDinh) ? moment(this.props.item.ngayQuyetDinh).format("DD/MM/YYYY") : ''}</td>
        <td>
          <ShowIf condition={!checkServerLive}>
            <Link className="txt-underline txt-blue" onClick={fileDownload.bind(this, this.props.item.duongDan, this.props.item.tenFile)}>{(this.props.item.tenFile) ? this.props.item.tenFile : ''} </Link>
          </ShowIf>
          <ShowIf condition={checkServerLive}>
            <Link className="txt-underline txt-blue" onClick={()=>{downloadFile(this.props.item.duongDan, this.props.item.tenFile)}}>{(this.props.item.tenFile) ? this.props.item.tenFile : ''} </Link>
          </ShowIf>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/datatable/rowItem/ListAttachTaiLieuRowItem.jsx